import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard/Dashboard';

// ✅ Импортируем ВСЕ страницы, чтобы роутер мог их корректно отображать
import StatisticsPage from './components/Dashboard/pages/StatisticsPage';
import NSPage from './components/Dashboard/pages/NSPage';
import DevicesPage from './components/Dashboard/pages/DevicesPage';
import ReportsPage from './components/Dashboard/pages/ReportsPage/ReportsPage';
import ArchiveReportPage from './components/Dashboard/pages/ReportsPage/ArchiveReportPage';
import MapPage from './components/Dashboard/pages/MapPage/MapPage';
import AnalysisPage from './components/Dashboard/pages/analysis/AnalysisPage';
import MainSettingsPage from './components/Dashboard/pages/MainSettingsPage';
import AdminPage from './components/Dashboard/pages/AdminPage';

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    if (!token) return <Navigate to="/login" replace />;
    return children || <Outlet />;
};

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/login" element={<LoginPage />} />

                {/* Защищенный Layout */}
                <Route path="/" element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                }>
                    <Route index element={<Navigate to="/dashboard" replace />} />

                    {/* ✅ Добавлены ВСЕ маршруты. Теперь при клике URL меняется корректно, 
                        и catch-all (*) больше не перехватывает их */}
                    <Route path="dashboard" element={<StatisticsPage />} />
                    <Route path="ns" element={<NSPage />} />
                    <Route path="devices" element={<DevicesPage />} />
                    <Route path="map" element={<MapPage />} />
                    <Route path="analysis" element={<AnalysisPage />} />
                    <Route path="mainsettings" element={<MainSettingsPage />} />
                    <Route path="admin" element={<AdminPage />} />
                    <Route path="reports" element={<ReportsPage />} />
                    <Route path="reports/archive" element={<ArchiveReportPage />} />
                </Route>

                {/* Ловушка для неизвестных маршрутов (строго в конце!) */}
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
        </Router>
    );
}

export default App;